import isBrowser from '@src/quince-site-common/src/utils/isBrowser'

// Cache for element references
const elementCache = new Map<string, HTMLElement | null>()

// Element IDs
const ELEMENT_IDS = {
  LB_USER_ID: 'ssr-cookie-lb-user-id',
  SESSION_ID: 'ssr-cookie-session-id',
} as const

/**
 * Gets an element from cache or fetches it from DOM
 * @param id - The element ID to retrieve
 * @returns The cached element or null if not found
 */
function getCachedElement(id: string): HTMLElement | null {
  if (!isBrowser()) return null

  // Check cache first
  if (elementCache.has(id)) {
    return elementCache.get(id) || null
  }

  // Cache miss - get element and cache it
  const element = document.getElementById(id)
  elementCache.set(id, element)
  return element
}

/**
 * Gets an element value with caching, but re-fetches if value is not truthy
 * @param id - The element ID to retrieve
 * @returns The element value or null
 */
function getCachedElementValue(id: string): string | null {
  if (!isBrowser()) return null

  // Get cached element
  const element = getCachedElement(id)

  // If element exists, try to get its value
  if (element) {
    const value = (element as HTMLInputElement).value
    // If value is truthy, return it
    if (value) {
      return value
    }
  }

  // Value is not truthy or element doesn't exist - ignore cache and try again
  const freshElement = document.getElementById(id)
  if (freshElement) {
    const freshValue = (freshElement as HTMLInputElement).value
    // Update cache with fresh element
    elementCache.set(id, freshElement)
    return freshValue || null
  }

  return null
}

export function getLbUserIdFromHtmlHiddenField() {
  return getCachedElementValue(ELEMENT_IDS.LB_USER_ID)
}

export function getSessionIdFromHtmlHiddenField() {
  return getCachedElementValue(ELEMENT_IDS.SESSION_ID)
}
